import script from "./EjecucionPreventivo.vue?vue&type=script&setup=true&lang=js"
export * from "./EjecucionPreventivo.vue?vue&type=script&setup=true&lang=js"

import "./EjecucionPreventivo.vue?vue&type=style&index=0&id=9a06b974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a06b974"]])

export default __exports__